import { createBreakpoints } from '@chakra-ui/theme-tools'
import { extendTheme } from '@chakra-ui/react'

// export const breakpoints = createBreakpoints({
//   sm: '48em',
// })
export const breakpoints = createBreakpoints({ sm: '768px', md: '768px', lg: '768px', xl: '768px', '2xl': '768px' })

const spBaseWidth = 750

export const vw = (size: number, baseWidth = spBaseWidth) => {
  return `${(size / baseWidth) * 100}vw`
}

export const theme = extendTheme({
  breakpoints,
  fonts: {
    body: 'Hiragino, Meiryo, sans-serif',
    headline1: '"A1明朝", A1 Mincho',
    headline2: '"見出ゴMB31",Midashi Go MB31',
    headlineEn: 'arial, sans-serif',
  },
  fontWeights: {},
  colors: {
    text: {
      50: '#ffffff',
      100: '#aaaaaa',
      200: '#818181',
    },
    hover: '#00ffc2',
    background: {
      black: '#000000',
      gray: '#111111',
    },
  },
  sizes: {
    contentMinWPC: '1366px',
    contentMinWSP: vw(550),
    contentPC: '1366px',
    contentSP: vw(550),
  },
  styles: {
    global: {
      html: {
        height: '100%',
      },
      body: {
        fontFamily: 'body',
        color: 'text.50',
        backgroundColor: 'background.black',
        fontFeatureSettings: 'palt',
        height: '100%',
        overscrollBehaviorY: 'none',
        lineHeight: '1',
      },
      a: {
        textDecoration: 'underline',
        transition: 'all 0.25s',
        '&:link': {
          color: 'inherit',
        },
        '&:visited': {
          color: 'inherit',
        },
        '&:hover': {
          color: 'hover',
        },
        '&:active': {
          color: 'inherit',
        },
        '&:focus': {
          color: 'inherit',
        },
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontFamily: 'body',
      },
    },
    Button: {
      baseStyle: {
        _focus: {
          outline: 'none',
          boxShadow: 'none',
        },
      },
    },
    Modal: {
      baseStyle: {
        dialogContainer: {
          '@supports(height: -webkit-fill-available)': {},
        },
      },
    },
  },
})
